// packages/content/src/strings/fishing.ts (M1-T15) — the catch card, misses and the fish log
import type { StringBank } from '../schema/strings';
export default {
  caught: 'I caught {fish:a}!', size: '{size} cm', tooEarly: 'Too soon. It swam off.', missed: 'It got away.',
  handFull: 'Your pockets are full. Drop it or let it go?', keep: 'Keep it',
  logTitle: 'Fish log', logCount: 'Caught {count}', logBiggest: 'Biggest: {size} cm', logUnknown: '???', logProgress: '{n} of {total} species',
} as const satisfies StringBank;
